/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { StackDeployment, RouteMapper } from './types'

// Creates a route mapper function that maps OneConsole API paths to internal endpoints
export const createRouteMapper =
  (deployment: StackDeployment): RouteMapper =>
  (path: string): string => {
    if (path === '/api/console/api_server') {
      return '/one-console/api_server'
    }

    if (path === '/api/console/proxy') {
      const deploymentId = deployment?.id
      return `/one-console/proxy${deploymentId ? `?deploymentId=${deploymentId}` : ''}`
    }

    return path
  }
